import {FixedFooter} from 'components/common/FixedFooter'
import {Button} from 'components/system/Button'
import {useNextStepperPath} from 'hooks/useNextStepperPath'
import {useOrderActivityDetails} from 'hooks/useOrderActivityDetails'
import {useOrderQuestions} from 'hooks/useOrderQuestions'
import {usePreviousStepperPath} from 'hooks/usePreviousStepperPath'
import {useSetQuestionAnswersMutation} from 'hooks/ventrata/useSetQuestionAnswersMutation'
import {useActivityPath} from 'providers/EnvironmentProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {useCallback} from 'react'
import {Form} from 'react-final-form'
import {Basic} from 'types'
import {convertUnitItemsToRequestUnitItems} from 'utils/convertUnitItemsToRequestUnitItems'
import {BookingDetails} from './BookingDetails'
import {isRequiredFieldsFilled} from './utils/isRequiredFieldsFilled'

export const Screen = () => {
  const order = OrderProvider.useOrder()
  const activityPath = useActivityPath()
  const nextPath = useNextStepperPath(activityPath)
  const previousPath = usePreviousStepperPath(activityPath)
  const setQuestionAnswersMutation = useSetQuestionAnswersMutation()
  const setQuestionAnswers = setQuestionAnswersMutation.mutate
  const setOrder = OrderProvider.useOrderSetter()

  const back = useCallback(() => {
    window.location.href = previousPath
  }, [previousPath])

  const onSubmit = useCallback(
    async (values: Basic.OrderActivityDetails) => {
      const bookingsUnitItems = order.bookings.map((booking) => {
        return {
          bookingUuid: booking.uuid,
          unitItems: convertUnitItemsToRequestUnitItems(booking.unitItems, values[booking.uuid]),
        }
      })

      setQuestionAnswers(
        {orderId: order.id, bookingsUnitItems},
        {
          onSuccess(order) {
            setOrder(order)
            window.location.href = nextPath
          },
        }
      )
    },
    [nextPath, setQuestionAnswers, order, setOrder]
  )

  const orderQuestions = useOrderQuestions()
  const orderActivityDetails = useOrderActivityDetails()

  return (
    <div className="flex flex-col gap-6">
      <div className="text-2xl font-bold">Activity details</div>
      <Form
        initialValues={orderActivityDetails}
        onSubmit={onSubmit}
        render={({handleSubmit, values}) => {
          const isSubmitDisabled = !isRequiredFieldsFilled(orderQuestions, values)

          return (
            <form onSubmit={handleSubmit} className="flex flex-col gap-6" id="activity">
              {orderQuestions.length === 0 ? (
                <div className="text-xl font-bold">No details required</div>
              ) : (
                <>
                  {orderQuestions.map((bookingQuestion) => {
                    return <BookingDetails key={bookingQuestion.bookingUuid} bookingQuestions={bookingQuestion} />
                  })}
                </>
              )}
              <FixedFooter>
                <div className="flex gap-2">
                  <Button.Back onClick={back} className="block d:hidden" />
                  <Button.Primary.Orange disabled={isSubmitDisabled} type="submit" expanded form="activity">
                    Next
                  </Button.Primary.Orange>
                </div>
              </FixedFooter>
            </form>
          )
        }}
      />
    </div>
  )
}
